export default __webpack_public_path__ + "static/media/single-project-page-04-img11.fc31898f.jpg";